
const ContactUs = () => {
  // const initValues= {
  //   name : "",
  //   phoneNumber: "",
  //   message: "",
  // } 

  // const [loading, setLoading] = useState(false)

  // const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/


  // const validationSchema = Yup.object().shape({
  //   name: Yup
  //     .string()
  //     .matches(/^[A-Za-z ]*$/, 'Please enter valid name')
  //     .min(3)
  //     .max(40)
  //     .required("Required"),
  //   message: Yup
  //     .string()
  //     .min(3)
  //     .required("Required"),
  //   phoneNumber: Yup
  //     .string()
  //     .required("Required")
  //     .matches(phoneRegExp, 'Phone number is not valid')
        
  // })

  // const onSubmit = (data, { resetForm }) => {
  //   setLoading(true)

  //   swal({
  //     icon: 'success',
  //     title: 'Your Info',
  //     text: JSON.stringify(data),
  //     buttons: true
  //   }).then(r => {
  //     resetForm()
  //     setLoading(false)
  //   })
    
  // }

  return (
    <div className={`h-full w-full text-center py-7 overflow-hidden`}>
      <h1 className='text-[28pt] font-semibold'>Contact Us</h1>
      <div className='w-full flex flex-row items-center justify-start text-black p-3 md:ml-20'>
        <div className='p-2 text-lg font-light w-[375px] text-justify'>
          <h1 className='text-lg font-semibold font-poppins mb-[7px]'>Our Contacts</h1>
          <ul className='flex flex-col items-start gap-y-2'>
            <li>+265 997 000 631</li>
            <li>+265 884 981 662</li>
            <li>mlimiwamakono@gmail.com</li>
          </ul>
        </div>
      </div>
      <div className={`flex flex-col w-full justify-evenly items-center flex-wrap mt-6 gap-y-5`}>
       {/* <Formik
        initialValues={initValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >

        {({ errors, touched, dirty, isValid }) => (
            <Form className='flex flex-col w-full sm:max-w-[365px] ss:max-w-[365px] md:max-w-2xl  gap-y-2'>
                <h1 className='text-[18pt] animate-pulse'>Leave a message here</h1>
                <div className='flex md:flex-row flex-1 flex-col gap-3 shadow-xl max-w-2xl py-3 px-2 rounded-2xl'>
                    <div className='flex flex-col flex-1 items-start p-2 gap-y-4 ' >
                        <div className="flex flex-col items-start gap-y-1 w-full">
                            <label htmlFor=""
                                className="text-lg px-2 font-semibold font-poppins text-primary"
                            >
                              Full Name* :
                            </label>
                            <div className='flex w-full animate-pulse flex-row items-end text-black font-medium justify-end px-2'>
                                <ErrorMessage name='name'/>
                            </div>
                            <Field
                                id="name" 
                                name="name"
                                className={touched.name && errors.name ? 
                                "w-full p-3 rounded-lg px-5 text-red-800 border-2 border-red-700" :
                                "w-full p-3 rounded-lg px-5 text-black border-2 border-gray-600"}
                                autoComplete="off"
                            />
                        </div>

                        <div className="flex flex-col items-start gap-y-1 w-full">
                            <label htmlFor=""
                                className="text-lg px-2 font-semibold font-poppins text-black"
                            >
                                Phone Number* :
                            </label>
                            <div className='flex w-full animate-pulse flex-row items-end text-black font-medium justify-end px-2'>
                                <ErrorMessage name='phoneNumber'/>
                            </div>
                            <Field
                                type="text"
                                id="phoneNumber" 
                                name="phoneNumber"
                                className={touched.phoneNumber && errors.phoneNumber ? 
                                "w-full p-3 rounded-lg px-5 text-red-800 border-2 border-red-700" :
                                "w-full p-3 rounded-lg px-5 text-black border-2 border-gray-600"}
                                autoComplete="off"
                            />
                        </div>

                        <div className="flex flex-col items-start gap-y-1 w-full">
                            <label htmlFor=""
                                className="text-lg px-2 font-semibold font-poppins text-primary"
                            >
                              Your message* :
                            </label>
                            <div className='flex w-full animate-pulse flex-row items-end text-black font-medium justify-end px-2'>
                                <ErrorMessage name='message'/>
                            </div>
                            <Field
                                name="message"
                                id="message"
                                as='textarea'
                                className={touched.message && errors.message ? 
                                "w-full p-3 rounded-lg px-5 text-red-800 border-2 border-red-700" :
                                "w-full p-3 rounded-lg px-5 text-black border-2 border-gray-600"}
                                autoComplete="off"
                            />
                        </div>
                    </div>
                </div>
                
                <div className='w-full flex flex-col items-end justify-center'>
                    <button 
                        type='submit'
                        className={
                        !(dirty && isValid) ? 
                        "border-2 border-black p-2 bg-white bg-opacity-60 text-green-900 rounded-xl px-5 "
                        : 'border-2 border-green-700 p-3 bg-green-400 bg-opacity-80 text-primary rounded-xl px-5'
                        }>
                            {
                                loading ? "Sending... " : "Send"
                            } 
                    </button>
                </div> 
            </Form>
        )}
           
      </Formik>  */}
      </div>
    </div>
  )
}

export default ContactUs
